import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-info mb-2">
      <div className="collapse navbar-collapse" id="navbarText">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <Link to="/" className="nav-link">Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/provinces" className="nav-link">Provinsi</Link>
          </li>
          <li className="nav-item">
            <Link to="/watchlist" className="nav-link">Watch List</Link>
          </li>
        </ul>
        <span className="navbar-text">
          Informasi Perkembangan Covid-19 Indonesia Ter-Update
        </span>
      </div>
    </nav>
  )
}

export default Navbar